import { useState, useCallback, useMemo } from 'react';

const SECTION_LABELS = {
  diagnoses: 'Diseases',
  phenotypes: 'Phenotypes',
  genotypes: 'Genotypes',
  tags: 'Tags',
  externalFamilyIds: 'External IDs'
};

const INITIAL = {
  diagnoses: false,
  phenotypes: false,
  genotypes: false,
  tags: false,
  externalFamilyIds: false
};

export function useDirtyState() {
  const [dirty, setDirty] = useState(INITIAL);

  const markDirty = useCallback((section) => {
    setDirty((prev) => (prev[section] ? prev : { ...prev, [section]: true }));
  }, []);

  const markClean = useCallback((section) => {
    setDirty((prev) => (prev[section] ? { ...prev, [section]: false } : prev));
  }, []);

  const markAllClean = useCallback(() => setDirty(INITIAL), []);

  const isDirty = useCallback((section) => dirty[section] ?? false, [dirty]);

  const dirtyCount = useMemo(
    () => Object.values(dirty).filter(Boolean).length,
    [dirty]
  );

  const dirtySections = useMemo(
    () =>
      Object.entries(dirty)
        .filter(([, v]) => v)
        .map(([k]) => k),
    [dirty]
  );

  const dirtySectionLabels = useMemo(
    () => dirtySections.map((k) => SECTION_LABELS[k] ?? k),
    [dirtySections]
  );

  return {
    markDirty,
    markClean,
    markAllClean,
    isDirty,
    dirtyCount,
    dirtySections,
    dirtySectionLabels
  };
}
